import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';

import { ONBOARDING_API_CONFIG, OnboardingApiConfigInterface } from '@planone/bau365/data-access-onboarding';

import { Profession } from '@planone/bau365/util-fair-data';
import { concatMap, map, Observable, of } from 'rxjs';

@Injectable()
export class DataAccessProfessionsService {
  constructor(
    private httpClient: HttpClient,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(ONBOARDING_API_CONFIG)
    private onboarding_api_config: OnboardingApiConfigInterface
  ) {}

  getProfession(fairId: string, professionId: string) {
    return this.httpClient.get<Profession>(
      `${this.onboarding_api_config.fairDataGatewayUrl}/fairs/${fairId}/professions/${professionId}`
    );
  }

  getProfessionsByIds(fairId: string, ids: string[] | undefined) {
    if (!ids) {
      return <Observable<Profession[]>>of([]);
    }

    let observable: Observable<Profession[]> = of([]);

    ids.forEach((id: string) => {
      observable = observable.pipe(
        concatMap((list) =>
          this.getProfession(fairId, id).pipe(map((profession: Profession) => list.concat([profession])))
        )
      );
    });

    return observable;
  }
}
